import PropTypes from 'prop-types';

import SwipeableDrawer from '@mui/material/SwipeableDrawer';

const CUNotificationsDrawer = (props) => {
  const { isCUNotificationsShown, onDrawerOpen, onDrawerClose, children } =
    props;

  return (
    <SwipeableDrawer
      anchor="right"
      open={isCUNotificationsShown}
      onOpen={onDrawerOpen}
      onClose={onDrawerClose}
      ModalProps={{
        BackdropProps: {
          invisible: true,
        },
      }}
      PaperProps={{
        sx: {
          overflowY: 'initial', // fixes Safari position:fixed issue - https://stackoverflow.com/questions/55023088/fixed-position-in-safari
        },
      }}
      disableSwipeToOpen
      disableDiscovery
    >
      {children}
    </SwipeableDrawer>
  );
};

CUNotificationsDrawer.propTypes = {
  isCUNotificationsShown: PropTypes.bool.isRequired,
  onDrawerOpen: PropTypes.func.isRequired,
  onDrawerClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default CUNotificationsDrawer;
